// extracted by mini-css-extract-plugin
export default {"block__title":"Block_block__title__gQtBY"};